import Skeleton from "react-loading-skeleton";
import { classNames, TranslatedString } from "@ct-react/core";
import { SkeletonableProps, WithTitle } from "../../tools/components";
import "./description.scss";
import InfoBox from "../common/info-box";
import { IconLanguageOff } from "@tabler/icons-react";
import { defineMessages, useIntl } from "react-intl";

const transDefs = defineMessages({
  reference: { id: "article.reference", defaultMessage: "Réf: {value}" },
  empty: { id: "article.description-empty", defaultMessage: "Il n'y a aucune description pour ce bien." },
  language: { id: "article.description-language", defaultMessage: "Cette information n'est pas disponible dans votre langue." }
});

type Props = {
  referenceId?: string;
  text?: TranslatedString;
  classification?: any;
}

const DescriptionPart = ({ className, loading, title, subTitle, data }: WithTitle<SkeletonableProps<Props>>) => {

  const intl = useIntl();

  const wrapperClasses = classNames("description-part", className);

  if (loading || !data)
    return (
      <div className={wrapperClasses}>
        <h2><Skeleton width="33%" /></h2>
        {!!subTitle && <Skeleton containerClassName="sub-title" width="50%" />}
        <Skeleton count={6} />
        <Skeleton width="25%" />
        <br />
        <Skeleton count={4} />
        <Skeleton width="65%" />
      </div>);

  return (
    <div className={wrapperClasses}>
      {!!data.referenceId &&
        <span className="ref">
          {intl.formatMessage(transDefs.reference, { value: data.referenceId })}
        </span>
      }
      <h2>{title}</h2>
      {!!subTitle &&
        <div className="sub-title">{subTitle}</div>
      }
      {!data.text
        ? <InfoBox formatting="for-language"
                   icon={<IconLanguageOff />}
                   msg={intl.formatMessage(transDefs.empty)}
                   inline={true} />
        : <>
            {!data.text.matchLang &&
              <InfoBox formatting="for-language"
                       icon={<IconLanguageOff />}
                       msg={intl.formatMessage(transDefs.language)}
                       inline={true} />
            }
            <div className="html-format" dangerouslySetInnerHTML={{ __html: data.text.value }} />
          </>
      }
    </div>);

}


export default DescriptionPart;
